import React, { useEffect } from 'react'
import EventsBanner from '../components/Events/EventsUpcoming'
import EventsBanner1 from '../components/Events/EventsBanner1'
import EventAbout from '../components/Events/EventAbout'
import PastEvents from '../components/Events/PastEvents'
import EventKeynotes from '../components/Events/EventKeynotes'
import EventGallery from '../components/Events/EventGallery'
import EventCTA from '../components/Events/EventCTA'

const EventPage = () => {
    useEffect(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, []);
    return (
        <div>
            <EventsBanner1 />
            <EventAbout/>
            <EventsBanner />
            <PastEvents />
            <EventKeynotes />
            <EventGallery />
            <EventCTA/>
        </div>
    )
}

export default EventPage
